<template>
  <span class="blu-ipt-number control has-addons" :class="{'is-disabled': disabled}" v-if=" type==='updown' " >
    <a class="button butt100" :class="{'is-disabled': disabledl}" @click="decrease" v-if="mode==='s'">
      <span class="icon is-small">
        <i class=" iconfont icon-minus"></i>
      </span>
    </a>
    <input class="input" :class="[sizeClass]" type="text" v-model="interVal" @keydown="handleKeyDown">
    <a class="button butt100 is-updown" :class="[sizeClass]" @click="decrease" v-if="mode!=='s'">
      <span class="icon is-small">
        <i class="iconfont icon-minus"></i>
      </span>
    </a>
    <a class="button butt100 " :class="{'is-disabled': disabledr}" @click="increase">
      <span class="icon is-small">
        <i class=" iconfont icon-tianjia"></i>
      </span>
    </a>
  </span>


    <span class="blu-ipt-number control has-addons" :class="{'is-disabled': disabled}"  v-else >

    <input class="input" :class="[sizeClass]" type="text" v-model="interVal" @keydown="handleKeyDown">

      <div class="upbox">
    <a class="button butt100 is-updown" :class="[sizeClass]" @click="increase">
      <span class="icon is-small">
        <i class="fa fa-angle-up"></i>
      </span>
    </a>

    <a class="button butt100 is-updown"  :class="[sizeClass]"  @click="decrease">
      <span class="icon is-small">
        <i class="fa fa-angle-down"></i>
      </span>
    </a>

      </div>
  </span>





</template>
<script>
export default {
	name:'inputNumber',
  props: {
    min: {
      type: Number,
      default: 0,
    },
    type: {
      type: String,
      default:'updown',
    },
    max: {
      type: Number,
      default: Infinity,
    },
    step: {
      type: Number,
      default: 1,
    },
    disabled: Boolean,
    val: {
      type: Number,
      default: 0,
    },
    idx:{
      type: [Number,String],
      default: 0,
    },
    dataIdx:{
      type: [Number,String],
      default: 0,
    },
    onChange: {
      type: Function,
      default() {},
    },
    size: String,
    mode: {
      type: String,
      default: '',
    },
  },

  computed: {
    sizeClass() {
      return this.size ? `is-${this.size}` : null;
    },
  },

  data() {
    return {
      interVal: this.val,
      disabledl: false,
      disabledr:false,
    };
  },
  created(){
     if(this.val==this.min) this.disabledl=true;
     if(this.val==this.max) this.disabledr=true;
  },
  watch: {
    max(val){
       if(this.interVal + this.step==this.max +1){
            this.disabledr= true
        }else if(this.interVal + this.step>this.max +1){
            this.disabledr= true;
            this.interVal=this.max;
        }else{
            this.disabledr= false
        }
    },
    interVal(val, oldVal) {
      this.handleFormat(val);
      if (this.interVal !== Number(oldVal) && this.interVal !== '-') {
        if (isNaN(oldVal) && oldVal !== '-') return;
        this.$emit('input', this.interVal);
        this.onChange(this.interVal,this.idx,this.dataIdx);
      }
    },
  },

  methods: {
    handleFormat(val) {
      if (val !== '' && val !== '-') {
        this.interVal = isNaN(this.interVal) ? 0 : Number(this.interVal);
        if (this.interVal > this.max) this.interVal = this.max;
        if (this.interVal < this.min) this.interVal = this.min;
      }
    },
    increase() {
      if (this.max) {
        (this.interVal + this.step <= this.max) && this.changeVal(this.step);
        this.disabledl= false
          if(this.interVal + this.step==this.max +1){
            this.disabledr= true
          }
      } else {
        this.changeVal(this.step);
      }
    },
    decrease() {
      if (this.min || this.min === 0) {
        var _numb=this.interVal;
        (this.interVal - this.step >= this.min) && this.changeVal(-this.step);
        this.disabledr= false
        if(_numb - this.step <= this.min){
          this.disabledl= true
        }
      } else {
        this.changeVal(-this.step);
      }
    },
    changeVal(num) {
      if (this.disabled) return;
      this.interVal += num;
    },
    handleKeyDown(e) {
      if (e.keyCode === 38) {
        this.increase();
      } else if (e.keyCode === 40) {
        this.decrease();
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/input-number/InputNumber.vue